//function to get region - redirect url if region selected/ base on cookie
//show note that region is wrong based on IP
// !!!IMPORTANT be sure that cg-cookie.js added to store
const regionLinks = {
  "NA": {
    "link":"www.clickandgrow.com",
    "desc":"United States&nbsp;(USD;&nbsp;$)"
  },
  "CA": {
    "link":"ca.clickandgrow.com",
    "desc":"Canada&nbsp;(CAD;&nbsp;C$)"
  },
  "EU": {
    "link":"eu.clickandgrow.com",
    "desc":"Europe&nbsp;(EUR;&nbsp;€)"
  },
  "UK": {
    "link":"uk.clickandgrow.com",
    "desc":"United Kingdom&nbsp;(GBP;&nbsp;£)"
  }
};


function regionLinkClick (event) {
  event.preventDefault();
  document.dispatchEvent(new CustomEvent("selectRegionEvent", {detail: {link: event.currentTarget}}));
}


document.addEventListener("DOMContentLoaded", function () {
  const region = getCookie("cont_");
  const targetUrl = regionLinks[region]?.link;
  let clientLocation = getCookie('clientCont');

  //redirect based on cont_ cookie - based on selected region
  if(window.location.hostname != targetUrl && region != null && targetUrl != undefined){
    try {
     location.replace('https://' + targetUrl + location.pathname + location.search);
     return;
    } catch (error) {
      console.log(error);
    }
  }

  function redirectBasedOnIP(){
    if(region == null && clientLocation != null){
      const regionLink = regionLinks[clientLocation]?.link;
      const hostname = window.location.hostname;
      if(regionLink != null){
        setCookie("cont_", clientLocation);
        if(hostname != regionLink){
          location.replace('https://' + regionLink)
        }
      }
    }
  }
  function setClientLocation(location){
    const continent = location.continent.code
    const country = location.country.iso_code;
    const is_EU = location.country.is_in_european_union;
    let cookieVal = null
    if(is_EU){
      cookieVal = 'EU'
    } else if(country == 'UK') {
      cookieVal = 'UK'
    } else if(country == 'CA') {
      cookieVal = 'CA'
    }else if(continent == 'NA') {
      cookieVal = 'NA'
    }
    if(cookieVal!=null){
      setCookie('clientCont',cookieVal, 7);
      clientLocation = cookieVal
      redirectBasedOnIP();
    }
  }

   
  if(clientLocation == null){
    geoip2.country(setClientLocation, (error)=>{console.log(error);});
  }

  //event listner for region link on page region selector
  document.addEventListener('selectRegionEvent', function(event){
    const link = event.detail.link;
    const href = link.href.endsWith('/') ? link.href.slice(0, -1) : link.href;
    const regionLink = link.getAttribute('data-region');
    const currentRegionCookie = getCookie("cont_");
    if (regionLink && regionLink!='') {
      setCookie("cont_", regionLink);
    }else {
      //mostly work for SG
      deleteCookie("cont_")
    }
    try {
      hideRegionAlertDialog();
    } catch (error) {
      console.log(error)
    }
    if(currentRegionCookie != regionLink && regionLink && regionLink!=='' && window.location.pathname.indexOf('region-selector')== -1){
      location.replace(href + window.location.pathname + window.location.search);
    } else {
      location.replace(href);
    }
  })

  //Region alert dialog logic:
  const regionAlertdialogClosed = getCookie('region_alert_dialog_closed');
  const alertdialog = document.querySelectorAll('.cg_region_alertdialog');
  const alertDialogRegion = document.querySelectorAll('.cg_region_alertdialog .cg-current-region');
  alertDialogRegion.forEach(element=>{element.innerHTML = regionLinks[region]?.desc})

  // Can happen that region (cont_ cookie) is not set in the beginning of session and no redirection is done either
  // In this case check that region is set and if not then set
  function getDescByLink(data, link) {
    for (const key in data) {
      if (data[key].link === link) {
        return data[key].desc;
      }
    }
    return null;
  }
  
  if (region != null) {
    alertDialogRegion.forEach(element=>{element.innerHTML = regionLinks[region]?.desc})
  } else {
    alertDialogRegion.forEach(element=>{
      element.innerHTML = getDescByLink(regionLinks, window.location.hostname);
    })
  }
  
  function hideRegionAlertDialog(hide = true) {
    if (hide) {
      alertdialog.forEach(element => {
        element.classList.remove('alert-fade-in')
        element.addEventListener(
          "transitionend",
          () => {
            element.style.display = "none";
            setCookie('region_alert_dialog_closed', true, 1);
          },
          { once: true } // Run only once
        );
      })
    } else {
      alertdialog.forEach(element => { 
        element.style.display = "block";
        element.classList.add('alert-fade-in');
      })
      setTimeout(hideRegionAlertDialog, 7000);
      deleteCookie('region_alert_dialog_closed');
    }
  }

  if (regionAlertdialogClosed) {
    // Scenario when cookie has already been set
    // In this scenario the element the element has to be hidden again,
    // as it still lurks in the DOM otherwise and has opacity 0
    alertdialog.forEach(element => {
        element.classList.remove('alert-fade-in')
        element.style.display = "none";
      })
  } else {
    // Scenario on new browse or after cookies have been deleted
    hideRegionAlertDialog(false)
  }

  document.querySelectorAll("sidebar-button button[data-sidebar-button]")
  .forEach((btn) => {
    btn.addEventListener("click", (event) => {
      hideRegionAlertDialog();
    });
  })
  
  const closeRegionAlertdialogBtn = document.querySelectorAll('.close-alertdiolog')
  closeRegionAlertdialogBtn.forEach((element)=>{
    element.addEventListener('click', ()=>{
      hideRegionAlertDialog();
    })
  })

});